import d3 = require("d3");
import * as React from "react";
import {DataPoint} from "./common";
import {veboxDefaultTheme} from "../../../index";

interface Props {
    data?: DataPoint[];
    containerClassName?: string;
    labelClassName?: string;
    barFillColor?: d3.ValueFn<d3.BaseType, DataPoint, string | number | boolean>;
}

export class LineChart extends React.Component<Props> {

    private ref: React.RefObject<any>;
    private container: d3.Selection<any, any, any, any>;

    constructor(props) {
        super(props);
        this.ref = React.createRef();
    }

    public componentDidMount() {
        this.drawD3LineChart(this.props.data);
    }

    public render() {
        return (<svg className={this.props.containerClassName} ref={this.ref}/>);
    }

    public componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<any>, snapshot?: any) {
        if (prevProps.data !== this.props.data) {
            this.updateLineChart(this.props.data);
        }
    }

    private drawD3LineChart = (data: DataPoint[]) => {
        const refHeight: number = this.ref.current.clientHeight;
        const refWidth: number = this.ref.current.clientWidth;

        const xScale = d3.scaleBand()
            .domain(data.map((x) => x.label))
            .rangeRound([0, refWidth])
            .padding(.1);

        const upperDelta = 1;

        const bottomLabelHeight = 20;

        const height = refHeight - bottomLabelHeight;

        const yScale = d3.scaleLinear()
            .domain(
                [0, Math.max(...data.map((x) => x.value)) + upperDelta],
            )
            .range([height, 0]);

        this.container = d3.select(this.ref.current)
            .classed(this.props.containerClassName, true);

        const flatLine = d3.line<DataPoint>()
            .curve(d3.curveBasis)
            .x((d) => xScale(d.label) + xScale.bandwidth() / 2)
            .y((d) => yScale(0));

        const line = d3.line<DataPoint>()
            .curve(d3.curveBasis)
            .x((d) => xScale(d.label) + xScale.bandwidth() / 2)
            .y((d) => yScale(d.value));

        this.container
            .append("path")
            .datum(data)
            .attr("fill", "none")
            .attr("stroke", veboxDefaultTheme.palette.brand.main)
            .attr("stroke-width", 9)
            .attr("stroke-linecap", "round")
            .attr("d", flatLine)
            .transition()
            .duration(2000)
            .attr("d", line);

        this.container
            .selectAll("g.labels")
            .data(data)
            .enter()
            .append("text")
            .classed(this.props.labelClassName || "", true)
            .text((d) => d.label)
            .attr("x", (d) => xScale(d.label) + xScale.bandwidth() / 2)
            .attr("y", refHeight - 5);
    }

    private updateLineChart = (data: DataPoint[]) => {

        const refHeight: number = this.ref.current.clientHeight;
        const refWidth: number = this.ref.current.clientWidth;

        const xScale = d3.scaleBand()
            .domain(data.map((x) => x.label))
            .rangeRound([0, refWidth])
            .padding(.1);

        const upperDelta = 1;

        const bottomLabelHeight = 20;

        const height = refHeight - bottomLabelHeight;

        const yScale = d3.scaleLinear()
            .domain(
                [0, Math.max(...data.map((x) => x.value)) + upperDelta],
            )
            .range([height, 0]);

        const line = d3.line<DataPoint>()
            .curve(d3.curveBasis)
            .x((d) => xScale(d.label) + xScale.bandwidth() / 2)
            .y((d) => yScale(d.value));

        this.container
            .selectAll("path")
            .datum((x) => data)
            .transition()
            .duration(2000)
            .attr("d", line);
    }
}
